import { createStore } from "vuex";
import globalStore from "./global/store";
import engagementReportsStore from "./engagements/reports/store";
import { engagementsAudienceStore } from "./engagements/audience/store";
import { settingsAgentsStore } from "./settings/agents/store";
import engagementAttributionsStore from "./engagements/attributions/store";
import crossSellingStore from "./engagements/cross-selling/store";
import engagementDesignStore from "./engagements/design/store";
import { importWizardStore } from "./settings/import-v2/import-wizard/store";

export const appStore = createStore({
  modules: {
    global: {
      namespaced: true,
      ...globalStore,
    },
    engagementReport: {
      namespaced: true,
      ...engagementReportsStore,
    },
    engagementAudience: {
      namespaced: true,
      ...engagementsAudienceStore,
    },
    engagementAttribution: {
      namespaced: true,
      ...engagementAttributionsStore,
    },
    engagementCrossSelling: {
      namespaced: true,
      ...crossSellingStore,
    },
    engagementDesignStore: {
      namespaced: true,
      ...engagementDesignStore,
    },
    settingsAgents: {
      namespaced: true,
      ...settingsAgentsStore,
    },
    importWizard: {
      namespaced: true,
      ...importWizardStore,
    },
  },
});
